import { type RouteObject } from 'react-router-dom';

import { firstAllowed, requirePermissions } from '@/app/requirePermissions';
import { type ItemType, itemTypes } from '@/models/item/item';
import { PagePermissions } from '@/models/pagePermissions';

// Bundles have their own read permission; the other Catalog pages ride on items:read.
const permissionsFor = (type: ItemType) =>
  type === 'bundle'
    ? PagePermissions.catalogBundles
    : PagePermissions.catalogItems;

export const itemRoute: RouteObject = {
  path: 'items',
  children: [
    {
      path: '',
      // 'item' and 'currency' share items:read, so Bundles is the only other candidate.
      loader: firstAllowed([
        { to: 'item', oneOf: PagePermissions.catalogItems },
        { to: 'bundle', oneOf: PagePermissions.catalogBundles },
      ]),
    },
    // season_pass is managed under its own /season-passes route, not as an item.
    ...itemTypes
      .filter((type) => type !== 'season_pass')
      .map(
        (type: ItemType): RouteObject => ({
          path: type,
          loader: requirePermissions({ oneOf: permissionsFor(type) }, () => ({
            type,
          })),
          lazy: () => import('./items'),
        }),
      ),
  ],
};
